var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "activity-detail-panel-footer" },
    [
      _c(
        "CompassTooltip",
        {
          attrs: {
            disabled: _vm.canBeUpdated,
            content: _vm.$t.__(
              "common.labels.no_permissions_to_perform_this_action"
            ),
            arrow: false
          }
        },
        [
          _vm.canReschedule
            ? _c(
                "ActivitiesRescheduleDatePicker",
                {
                  attrs: { value: _vm.activityDate, placement: "top-end" },
                  on: {
                    "update:value": function(value) {
                      return _vm.$emit("updateDueDate", value)
                    }
                  }
                },
                [
                  _c("CompassButton", {
                    attrs: {
                      loading: _vm.isReschedulePending,
                      type: "secondary",
                      dropdown: true,
                      label: _vm.$t.__(
                        "activities.detailPanel.ActivityDetailPanel.rescheduleButton"
                      ),
                      disabled: !_vm.canBeUpdated
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassTooltip",
        {
          attrs: {
            disabled: _vm.canBeUpdated,
            content: _vm.$t.__(
              "common.labels.no_permissions_to_perform_this_action"
            ),
            arrow: false
          }
        },
        [
          _c("ActivityUpdateStatusButton", {
            attrs: {
              isDone: _vm.isDone,
              disabled: !_vm.canBeUpdated,
              pending: _vm.pending,
              label: _vm.statusButtonLabel,
              statusButtonType: _vm.statusButtonType,
              hasDropdown: _vm.hasDropdown
            },
            on: {
              updateStatus: function(createNewTask) {
                return _vm.$emit("updateStatus", createNewTask)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }